import { Spinner } from '@appcues/sonar';
import styled from 'styled-components';

const LoadingOverlayContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: var(--background-level-1);
    z-index: 1;
  }
`;

const SpinnerContainer = styled.div`
  position: relative;
  z-index: 2;
`;

const LoadingOverlay = () => {
  return (
    <LoadingOverlayContainer>
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    </LoadingOverlayContainer>
  );
};

export default LoadingOverlay;
